var _path, _path2, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIUser = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 18C36 27.9411 27.9411 36 18 36C8.05887 36 0 27.9411 0 18C0 8.05887 8.05887 0 18 0C27.9411 0 36 8.05887 36 18ZM22.7308 14.1795C22.7308 16.6624 20.7208 18.6667 18.2308 18.6667C15.7408 18.6667 13.7308 16.6624 13.7308 14.1795C13.7308 11.6966 15.7408 9.69231 18.2308 9.69231C20.7208 9.69231 22.7308 11.6966 22.7308 14.1795ZM18.2308 19.7137C15.2308 19.7137 9.23077 21.359 9.23077 24.3504V25.8462H27.2308V24.3504C27.2308 21.359 21.2308 19.7137 18.2308 19.7137Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3864_214",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 18C36 27.9411 27.9411 36 18 36C8.05887 36 0 27.9411 0 18C0 8.05887 8.05887 0 18 0C27.9411 0 36 8.05887 36 18ZM22.7308 14.1795C22.7308 16.6624 20.7208 18.6667 18.2308 18.6667C15.7408 18.6667 13.7308 16.6624 13.7308 14.1795C13.7308 11.6966 15.7408 9.69231 18.2308 9.69231C20.7208 9.69231 22.7308 11.6966 22.7308 14.1795ZM18.2308 19.7137C15.2308 19.7137 9.23077 21.359 9.23077 24.3504V25.8462H27.2308V24.3504C27.2308 21.359 21.2308 19.7137 18.2308 19.7137Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3864_214)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIUser, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/i_user.1affe531.svg";
export { ForwardRef as ReactComponent };